import { useParams } from 'react-router-dom';

export const useAdRouteParams = () => {
  const params = useParams<{
    projectId: string;
    analyticalDatasetProfileId: string;
    analyticalDatasetVersionId: string;
  }>();
  return {
    projectId: params.projectId ?? '',
    analyticalDatasetProfileId: params.analyticalDatasetProfileId ?? '',
    analyticalDatasetVersionId: params.analyticalDatasetVersionId ?? '',
  };
};
